import React from "react";

export default function Space(props) {
    let {
        className = "",
        size = 6,
        style = {},
        width = "",
        height = false,
        justifyContent = "",
        flexDirection = "row",
        visible = true,
        gap = false,
        grow = false,
    } = props;

    style = { ...style };
    style.display = "flex";
    style.flexDirection = flexDirection;
    style.gap = size + "px";
    if (gap) {
        style.gap = gap;
    }
    style.height = height ? height + "px" : "auto";
    if (width) style.width = width + "px";
    if (justifyContent) style.justifyContent = justifyContent;
    if (!visible) style.opacity = ".5";


    if (grow) {
        if (!style.justifyContent) style.justifyContent = "flex-start";
        if (!style.alignItems) style.alignItems = "center";
    }

    let _class = "ui-space";
    if (className) _class += " " + className;

    return (
        <div style={style} className={_class}>

            {props.children}
            {/* {React.Children.map(props.children, (child, index) => {
                if (!React.isValidElement(child)) return child;

                return React.cloneElement(child, {
                    key: (child?.key) ? child.key : index, // 🔑 retain existing key
                    style: {
                        ...(child.props.style || {}),
                        flexGrow: grow ? 1 : 0,
                    },
                });
            })} */}
        </div>
    );
}
